module.exports = __webpack_public_path__ + "static/Group 7123-463179802c589acfddb1b5e6e013dd91.png";